// extracted by mini-css-extract-plugin
export default {"ButtonGroup":"ButtonGroup-module--ButtonGroup--kOM-8"};